import $ from "cash-dom";
import validate from "../fieldValidator.js";
import { goToFlow } from "./flowTargets.js";

$(function () {
  // Header Form Submit
  $(".search__form").on("submit", function (ev) {
    ev.preventDefault();
    handleFormSubmit(this);
  });
  $(".company-search__form").on("submit", function (ev) {
    ev.preventDefault();
    handleFormSubmit(this);
  });
  //Banner form submit
  $(".banner-mail__form").on("submit", function (ev) {
    ev.preventDefault();
    handleFormSubmit(this);
  });
});

function initKeyValidation(form) {
  $(form).on("input", function (ev) {
    ev.preventDefault();
    validateFields(this);
  });
}

function validateFields(form) {
  var values = validate.collectFormValues(form, "trim");
  var nameErrors = validate(values, nameConstraint);
  var companyErrors = validate(values, companyConstraint);
  var emailErrors = validate(values, emailConstraint);
  if (!emailErrors) {
    showErrors(form, emailErrors || {});
    return 1;
  } else if (!nameErrors) {
    showErrors(form, nameErrors || {});
    return 2;
  } else if (!companyErrors) {
    showErrors(form, companyErrors || {});
    return 3;
  } else {
    var errors = $.extend(nameErrors, companyErrors, emailErrors);
    showErrors(form, errors || {});
    return 4;
  }
}

let nameConstraint = {
  fn: {
    presence: {
      message: "^Please enter a name",
    },
    format: {
      pattern: "[a-z ]+",
      flags: "i",
      message: "^Alphabetic characters required",
    },
  },
};

let companyConstraint = {
  bn: {
    presence: {
      message: "^Please enter a company",
    },
    format: {
      pattern: "[a-z0-9 &,.]+",
      flags: "i",
      message: "^Alphanumeric characters required",
    },
  },
};

let emailConstraint = {
  emailInput: {
    presence: {
      message: "^Please enter an email address",
    },
    email: {
      message: "^Enter a correct email address",
    },
  },
};

function handleFormSubmit(form) {
  var validationStatus = validateFields(form);
  if (validationStatus == 1) {
    goToFlow($(form).data("subscribeFlow"));
  } else if (validationStatus == 2) {
    goToFlow($(form).data("peopleFlow"));
  } else if (validationStatus == 3) {
    goToFlow($(form).data("companyFlow"));
  } else {
    initKeyValidation(form);
  }
}

function showErrors(form, errors) {
  $(form)
    .find("input[name], select[name]")
    .each(function (index, input) {
      showErrorsForInput(input, errors && errors[input.name]);
    });
}

function showErrorsForInput(input, errors) {
  if (errors) {
    $(errors).each(function (i, error) {
      addError(input, error);
    });
  } else {
    $(input).parents("div.ps-input, div.input").removeClass("error");
    $(input).parents("div.ps-input, div.input").addClass("success");
    const inputName = $(input).attr("name");
    $(input)
      .siblings("label#" + inputName + "-error")
      .remove();
  }
}

function addError(input, error) {
  const inputName = $(input).attr("name");
  let label = $(input).siblings("label#" + inputName + "-error");
  $(input).parents("div.ps-input, div.input").addClass("error");
  if (label.length) {
    label.text(error);
  } else {
    let block = document.createElement("label");
    block.classList.add("error");
    block.innerText = error;
    block.id = inputName + "-error";
    $(input).after(block);
  }
}
